export default __webpack_public_path__ + "media/color/nas-1ee5c11c.svg";